import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500 md:text-sm">
      <Link to="/" className="flex items-center gap-1 text-foreground-500 transition-colors hover:text-primary-600 cursor-pointer">
        <i className="ri-home-4-line" aria-hidden="true"></i>
        首页
      </Link>
      {items.map((c, i) => (
        <span key={`${c.label}-${i}`} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true"></i>
          {c.to ? (
            <Link to={c.to} className="text-foreground-500 transition-colors hover:text-primary-600 cursor-pointer">
              {c.label}
            </Link>
          ) : (
            <span className="font-medium text-foreground-900">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}